import React from 'react';
import { Form, Formik } from 'formik';
import {
  Button,
  Card,
  Container,
  FormHelperText,
  Grid,
  LinearProgress,
  Typography
} from '@material-ui/core';
import * as yup from 'yup';
import Header from './Header';
import MySlider from './MySlider';
import MyRadioButton from './MyRadioButton';

function WeightliftingExperience({ formData, setFormData, nextPage, prevPage, goToContact }) {
  return (
    <React.Fragment>
      <Header title="Your experience with Olympic Weightlifting" />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            validationSchema={yup.object({
              weightliftingStats: yup.object({
                beenCoached: yup.string().required('Please select whether you have received coaching before.')
              })
            })}
            onSubmit={async (values, actions) => {
              let { technique } = values.weightliftingStats;

              // console.log(JSON.parse(JSON.stringify(values)));

              actions.setSubmitting(true);

              if (technique === 0) {
                values.weightliftingStats.experience = false;
              } else {
                values.weightliftingStats.experience = true;
              }

              setFormData(values);

              if (technique !== 0) {
                nextPage();
              } else {
                goToContact();
              }

            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MySlider
                        marks={[{
                          label: 'Never Lifted',
                          value: 0
                        }, {
                          label: '1',
                          value: 1
                        }, {
                          label: '2',
                          value: 2
                        }, {
                          label: '3',
                          value: 3
                        }, {
                          label: 'I\'m Elite',
                          value: 4
                        }]}
                        max={4}
                        name="weightliftingStats.technique"
                        value={formik.values.weightliftingStats.technique}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography gutterBottom>
                        Have you had any formal coaching?
                      </Typography>
                      <Grid item xs={12}>
                        <MyRadioButton
                          label="Yes"
                          name="weightliftingStats.beenCoached"
                          type="radio"
                          value="yes"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MyRadioButton
                          label="No"
                          name="weightliftingStats.beenCoached"
                          type="radio"
                          value="no"
                        />
                      </Grid>
                    </Grid>
                    {formik.errors.weightliftingStats && formik.touched.weightliftingStats ? (
                      <Grid item xs={12}>
                        <FormHelperText error>
                          {formik.errors.weightliftingStats.beenCoached}
                        </FormHelperText>
                      </Grid>
                    ) : null}
                    <Grid item xs={4}>
                      <Button disabled={formik.isSubmitting} variant="contained" onClick={prevPage} fullWidth>Back</Button>
                    </Grid>
                    <Grid item xs={8} style={{ margin: 'auto' }}>
                      {formik.isSubmitting ? (
                        <LinearProgress />
                      ) : (
                        <Button
                          color="primary"
                          fullWidth
                          type="submit"
                          variant="contained"
                        >
                          Next
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre>
                  <pre>{JSON.stringify(formik.errors, null, 2)}</pre> */}
                </Container>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default WeightliftingExperience;